export const TYPES = [
  { label: 'Android', value: 'android', selected: false },
  { label: 'iOS', value: 'ios', selected: false },
  { label: 'Website', value: 'web', selected: false }
];

export const DELIMITER_TYPES = [
  { title: 'Semicolon [ ; ]', key: ';' },
  { title: 'Comma [ , ]', key: ',' }
];

export const SOURCE_OPTIONS = [
  { label: 'Eraspace', value: 'eraspace' },
  { label: 'iBox', value: 'ibox' },
  { label: 'JDSport', value: 'jdsport' },
  { label: 'Erafone', value: 'erafone' }
];
